import React from 'react';

const Modal = ({
  children = null,
  onClose = () => { },
  statusModal = false,
}) => {
  const showHideClassName = statusModal ? 'modal-table show' : 'modal-table hide';
  const handleOnClick = (e) => {
    e.preventDefault();
    onClose();
  };
  return (
    <div className={showHideClassName}>
      <section className="modalMain">
        {children}
      </section>
    </div>
  );
};
export default Modal;
